import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')(() => ({
  width: '100%',
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.custom.tab,
  borderRadius: '1rem !important',

  '&:before': {
    display: 'none',
  },

  marginBottom: '1rem',
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  height: '6.7rem',
  padding: '0 3rem',
  alignItems: 'center',
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  flexDirection: 'column',
}));

export const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)(() => ({
  alignSelf: 'center',
  marginRight: '1rem',
}));

export const TypographyHeading = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1.7rem',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.6rem',
  },
}));
